// extracted by mini-css-extract-plugin
export default {"tabIcon":"ProfileTabs_tabIcon__-Bbei","profileTabs":"ProfileTabs_profileTabs__y6+Ld","tab":"ProfileTabs_tab__KEkF7","active":"ProfileTabs_active__I-IU8"};